<template>
  <div class='Room__main-container'
       :class="{'aside-opened': aside}">
    <div class='Room__header'>
      <div class='Room__header-main'>
        <div class='Room__info'>
          <div class='Room__info-item'>
            <i class='icon-ic_link Room__icon-link'></i>
            {{ conference.credentials.conferenceUrl }}
          </div>
          <div class='Room__info-item'>
            <i class='icon-ic_lock Room__icon-lock'></i>
            PIN {{ conference.credentials.conferencePin }}
          </div>
        </div>
        <div class='Room__call-info'>
          <div class='Room__call-info-timer'>
            {{ duration }}
          </div>
          <div class='Room__call-info-participants'>
            {{ title }}
          </div>
        </div>
        <room-actions
        :user="user"
        :conference="conference">
        </room-actions>
      </div>
      <div class='Room__header-sub'>
        <div v-if="!initializing && ownerIsPresent">
          <div class="Room__talking-participants">
            {{ talking }}
          </div>
          <i @click="muteAll"
             v-if="user.isOwner"
             class="icon-ic_mute-all Room__mute-all"></i>
        </div>
        <div v-if="!initializing && !ownerIsPresent"
             class="Room__header-missing-owner">
          Waiting for organizer (admin) to arrive…
        </div>
      </div>
    </div>

    <div class='Room__body'>
      <div class="Room__body-background"
        v-if="ownerIsPresent"
        :style="{'background-image': 'url('+owner.avatarUrl+')'}"></div>
      <div class="Room__body-background-overlay"
        :class="{'missing-owner': !initializing && !ownerIsPresent}"></div>
      <div class='Room__body-container'>
        <div
        name="fade"
        v-if="!initializing"
        class='Room__participants'
        :class="{'alone': participants.length === 1}">
          <div
          class='Room__participant'
          v-for='(participant, index) in participants'
          :key="index"
          :class='{ admin: participant.isAdmin, muted: participant.isMuted, talking: participant.isTalking }'>
            <img class="Room__participant-avatar"
                 v-if="getUserInfo(participant.userId).avatarUrl"
                 :src="getUserInfo(participant.userId).avatarUrl"/>
            <img v-else
                 class="Room__participant-avatar Room__participant-avatar--default"
                 src="../../../static/images/default-user-avatar.jpg"/>
            <div class="Room__participant-container">
              <div class="Room__participant-toolbar">
                <div class="Room__participant-info">
                  <i v-if="participant.isAdmin"
                     class="icon-ic_admin"></i>
                  <i v-if="participant.isMuted"
                     class="icon-ic_muted"></i>
                  <i v-if="false" class="icon-ic_handup"></i>
                </div>
                <participant-more-menu
                  v-if="user.isAdmin & user.userId !== participant.userId"
                  :user="participant"
                  :name="getUserInfo(participant.userId).name">
                </participant-more-menu>
              </div>
              <div class="Room__participant-name">
                {{ getUserInfo(participant.userId).name }}
              </div>
            </div>
          </div>
        </div>
        <i v-if="initializing"
           class="icon-ic_spinner Room__initializing-spinner"></i>
      </div>
      <audio
      :src="localStreamSrc"
      class="hidden"
      id="localStream"
      autoplay
      controls
      muted>
      </audio>
      <audio
      :src="remoteStreamSrc"
      class="hidden"
      id="remoteStream"
      autoplay
      controls>
      </audio>
    </div>

    <div class="Room__footer">
      <transition name="appear-from-bottom">
      <div class="Room__footer-actions"
           v-if="participants.length">
        <div class="Room__footer-action"
             @click="openSettings">
          <div class="Room__footer-action-btn">
            <i class="icon-ic_settings"></i>
          </div>
          <div class="Room__footer-action-description">
            Settings
          </div>
        </div>
        <div class="Room__footer-action"
             @click="mute">
          <div class="Room__footer-action-btn"
               :class="{'active': user.isMuted}">
            <i class="icon-ic_mute"></i>
          </div>
          <div class="Room__footer-action-description">
            {{ user.isMuted ? 'Muted' : 'Mute'}}
          </div>
        </div>
        <div v-if="user.isOwner"
             class="Room__footer-action"
             @click="lock">
          <div class="Room__footer-action-btn"
               :class="{'active': conference.status.locked}">
            <i class="icon-ic_lock-call"></i>
          </div>
          <div class="Room__footer-action-description">
            {{conference.status.locked ? 'Locked' : 'Lock'}}
          </div>
        </div>
        <div class="Room__footer-action"
             :class="{'invalidate': endCallInProcess}"
             @click="end">
          <div class="Room__footer-action-btn Room__end-call-btn">
            <i class="icon-ic_call_end Room__end-call-icon"></i>
          </div>
          <div class="Room__footer-action-description">
            {{ user.isOwner ? 'End Call' : 'Leave Call' }}
          </div>
        </div>
      </div>
      </transition>
    </div>

    <transition name="slide-right">
      <div :is="aside"
           class="Room__aside">
      </div>
    </transition>

    <settings-modal></settings-modal>
    <set-title-modal></set-title-modal>
    <notification-modal></notification-modal>
    <page-title :title="pageTitle"></page-title>
  </div>
</template>

<script>
  import PageTitle from '@/components/common/page-title/page-title';
  import SettingsModal from './settings.modal/settings.modal';
  import SetTitleModal from './set-title.modal/set-title.modal';
  import NotificationModal from './notification.modal/notification.modal';
  import ParticipantMoreMenu from './participant-more-menu/participant-more-menu';
  import RoomActions from './room-actions/room-actions';
  import InviteMenu from './invite-menu/invite-menu';
  import Chat from './chat/chat';

  export default {
    components: {
      SettingsModal,
      SetTitleModal,
      NotificationModal,
      ParticipantMoreMenu,
      RoomActions,
      InviteMenu,
      Chat,
      PageTitle
    },
    data() {
      return {
        now: Math.trunc((new Date()).getTime() / 1000),
        moreMenu: false,
        endCallInProcess: false,
        pageTitle: null
      };
    },
    computed: {
      localStreamSrc() {
        const audio = document.getElementById('localStream');
        if (audio != null && this.$store.getters.localStreamSrc != null) {
          audio.srcObject = this.$store.getters.localStreamSrc;
          audio.muted = true;
        }
        return this.$store.getters.localStreamSrc;
      },
      remoteStreamSrc() {
        const audio = document.getElementById('remoteStream');
        if (audio != null && this.$store.getters.remoteStreamSrc != null) {
          audio.srcObject = this.$store.getters.remoteStreamSrc;
        }
        return this.$store.getters.remoteStreamSrc;
      },
      ownerIsPresent() {
        return this.$store.getters.ownerIsPresent;
      },
      aside() {
        return this.$store.getters.aside;
      },
      conference() {
        return this.$store.getters.conference;
      },
      initializing() {
        return this.$store.getters.initializing;
      },
      user() {
        return this.$store.getters.user;
      },
      owner() {
        return this.$store.getters.owner;
      },
      participants() {
        return this.conference.status ? this.conference.status.participants : [];
      },
      title() {
        let title;
        if (this.conference.status && this.conference.status.title) {
          title = `${this.conference.status.title} (${this.participants.length})`;
          this.pageTitle = `KingsConference - ${this.conference.status.title}`;
        } else {
          title = `${this.participants.length || '1'} Participants`;
          this.pageTitle = `KingsConference - ${title}`;
        }
        return title;
      },
      talking() {
        const filtered = this.filterBy(this.participants, true, 'isTalking');
        const names = filtered.map(participant => this.getUserInfo(participant.userId).name);
        return names.join(', ');
      },
      duration() {
        let duration = '00:00';
        const start = this.$store.getters.startedAt;
        if (start && start < this.now) {
          const minutes = this.stringify(Math.trunc((this.now - start) / 60) % 60);
          const seconds = this.stringify((this.now - start) % 60);
          duration = `${minutes}:${seconds}`;
        }
        return duration;
      }
    },
    methods: {
      getUserInfo(id) {
        return this.$store.getters.usersInfo[id] || {};
      },
      stringify(n) {
        if (n.toString().length <= 1) {
          n = `0${n.toString()}`;
        }
        return n;
      },
      getParticipantAvatar(participant) {
        return `https://connect-kc.appunite.com/api/media/${participant.userId}`;
      },
      mute() {
        this.$store.dispatch('muteCall');
      },
      muteAll() {
        this.$store.dispatch('muteAll');
      },
      lock() {
        this.$store.dispatch('lockCall');
      },
      end() {
        this.endCallInProcess = true;
        this.$store.dispatch('endCall');
      },
      openSettings() {
        this.$modal.show('settings-modal');
      },
      openMoreMenu(participant) {
        this.moreMenu = participant.userId;
      },
      hideMoreMenu() {
        this.moreMenu = false;
      }
    },
    created() {
      this.interval = setInterval(() => {
        this.now = Math.trunc((new Date()).getTime() / 1000);
      }, 1000);
      const params = {
        username: this.$route.params.username,
        pin: this.$route.params.pin
      };
      this.$store.dispatch('joinRoom', params).then(() => {
        this.start = Math.trunc((new Date()).getTime() / 1000);
      });
    },
    destroyed() {
      clearInterval(this.interval);
      this.$store.dispatch('disconnectChat');
    }
  };
</script>

<style scoped lang='scss'>
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// room.vue?d119d132